import React from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SEO from '../components/SEO';

const DraftNotice = ({ t }) => (
  <div className="mb-8 rounded-lg border-l-4 border-amber-400 bg-amber-50 p-4 text-amber-900">
    <p className="font-bold">{t('legal.draftNotice.label')}</p>
    <p className="mt-1 text-sm leading-relaxed">{t('legal.draftNotice.body')}</p>
  </div>
);

const TermsOfService = () => {
  const { t } = useTranslation();
  const s = 'legal.terms.sections';

  const conductItems = t(`${s}.conduct.items`, { returnObjects: true });
  const lawItems = t(`${s}.governingLaw.items`, { returnObjects: true });
  const legalEmail = t(`${s}.contact.emailValue`);

  return (
    <>
      <SEO
        path="/terms-of-service"
        title={t('legal.terms.seo.title')}
        description={t('legal.terms.seo.description')}
        keywords={t('legal.terms.seo.keywords')}
      />
      <Header />
      <main className="bg-gray-50 py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white p-8 rounded-xl shadow-lg animate-fade-in animate-slide-up">
            <h1 className="text-3xl font-bold text-gray-900 mb-6">{t('legal.terms.title')}</h1>
            <p className="text-gray-600 mb-4">{t('legal.terms.lastUpdated')}</p>

            <DraftNotice t={t} />

            <div className="prose prose-green max-w-none">
              <h2>{t(`${s}.acceptance.heading`)}</h2>
              <p>{t(`${s}.acceptance.p1`)}</p>
              <p>{t(`${s}.acceptance.p2`)}</p>

              <h2>{t(`${s}.description.heading`)}</h2>
              <p>{t(`${s}.description.p1`)}</p>

              <h2>{t(`${s}.accounts.heading`)}</h2>
              <p>{t(`${s}.accounts.p1`)}</p>

              <h2>{t(`${s}.fees.heading`)}</h2>
              <p><strong className="text-csl-green">{t(`${s}.fees.s41Title`)}</strong></p>
              <p>{t(`${s}.fees.s41Body1`)}</p>
              <p>{t(`${s}.fees.s41Body2`)}</p>
              <p><strong className="text-csl-green">{t(`${s}.fees.s42Title`)}</strong></p>
              <p>{t(`${s}.fees.s42Body`)}</p>
              <p><strong className="text-csl-green">{t(`${s}.fees.s43Title`)}</strong></p>
              <p>{t(`${s}.fees.s43Body`)}</p>

              <h2>{t(`${s}.ip.heading`)}</h2>
              <p><strong className="text-csl-green">{t(`${s}.ip.s51Title`)}</strong></p>
              <p>{t(`${s}.ip.s51Body`)}</p>
              <p><strong className="text-csl-green">{t(`${s}.ip.s52Title`)}</strong></p>
              <p>{t(`${s}.ip.s52Body`)}</p>

              <h2>{t(`${s}.conduct.heading`)}</h2>
              <p>{t(`${s}.conduct.intro`)}</p>
              <ul>
                {(Array.isArray(conductItems) ? conductItems : []).map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>

              <h2>{t(`${s}.termination.heading`)}</h2>
              <p>{t(`${s}.termination.p1`)}</p>

              <h2>{t(`${s}.warranties.heading`)}</h2>
              <p>{t(`${s}.warranties.p1`)}</p>

              <h2>{t(`${s}.liability.heading`)}</h2>
              <p>{t(`${s}.liability.p1`)}</p>
              <p>
                {t(`${s}.liability.p2`)}{' '}
                <span className="italic text-amber-700">{t(`${s}.liability.capPlaceholder`)}</span>.
              </p>
              <p>{t(`${s}.liability.p3`)}</p>

              <h2>{t(`${s}.governingLaw.heading`)}</h2>
              <p>
                {t(`${s}.governingLaw.p1`)}{' '}
                <span className="italic text-amber-700">{t(`${s}.governingLaw.lawPlaceholder`)}</span>,{' '}
                {t(`${s}.governingLaw.p2`)}
              </p>
              <ul>
                {(Array.isArray(lawItems) ? lawItems : []).map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
              <p>
                {t(`${s}.governingLaw.venuePrefix`)}{' '}
                <span className="italic text-amber-700">{t(`${s}.governingLaw.venuePlaceholder`)}</span>{' '}
                {t(`${s}.governingLaw.venueSuffix`)}
              </p>

              <h2>{t(`${s}.disputeResolution.heading`)}</h2>
              <p>
                {t(`${s}.disputeResolution.p1`)}{' '}
                <a href={`mailto:${legalEmail}`}>{legalEmail}</a>,{' '}
                {t(`${s}.disputeResolution.p1Suffix`)}{' '}
                <span className="italic text-amber-700">{t(`${s}.disputeResolution.periodPlaceholder`)}</span>.
              </p>
              <p>
                {t(`${s}.disputeResolution.p2`)}{' '}
                <span className="italic text-amber-700">{t(`${s}.disputeResolution.mechanismPlaceholder`)}</span>.
              </p>
              <p>{t(`${s}.disputeResolution.p3`)}</p>

              <h2>{t(`${s}.changes.heading`)}</h2>
              <p>{t(`${s}.changes.p1`)}</p>

              <h2>{t(`${s}.contact.heading`)}</h2>
              <p>{t(`${s}.contact.p1`)}</p>
              <p>
                <strong>{t(`${s}.contact.emailLabel`)}:</strong> {legalEmail}<br />
                <strong>{t(`${s}.contact.addressLabel`)}:</strong> {t(`${s}.contact.addressValue`)}
              </p>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default TermsOfService;
